export const AppString = {
	// validation error message
	email_is_required: 'Email is required',
	please_enter_a_valid_email: 'Please enter a valid email',
	password_is_required: 'Password is required',
	user_token:'token',
	password_is_weak:'Password must be between 8 and 20 characters',
	phone_number_is_required: 'Phone number is required',
	invalid_phone_number: 'Invalid phone number',
	confirm_password_is_required: 'Confirm password is required',
	passwords_do_not_match: 'Passwords do not match',
	username_is_required: 'Username is required',
	firstname_is_required: 'fistName is required',
	lastname_is_required: 'lastname is required',
	login: 'Login',
	new_york_properties: 'New York Properties',
	email_id: 'Email Id',
	e_mail: 'E-mail',
	password: 'Password',
	dashboard: 'Dashboard',
	project_detail: 'Project Detail',
	all_project: 'All Projects',
	project_name: 'Project Name',
	client_name: 'Client Name',
	start_date: 'Start Date:',
	end_date: 'End Date:',
	interview_by: 'Interview By',
	scheduled_by: 'Sheduled by',
	employee: 'Employee',
	skils: 'Skils',
	select_stauts: 'Select Status',
	project_amount: 'Project Amount',
	cancel: 'Cancel',
	submit: 'Submit',
	are_you_sure_you_want_to_delete: 'Are you sure you want to delete',
	confirm_password: 'Confirm Password',
	signup: 'Signup',
	username: 'Username',
	enter_username: 'Enter Username',
	enter_email_id: 'Enter Email Id',
	enter_password: 'Enter Password',
	confirmr_password: 'Confirm Password',
	dont_have_account: 'Dont Have Account',
	already_have_account: 'Already Have Account',
	forgot_password: 'Forgot Password',
	phone_number: 'Phone number',
	enter_phone_number: 'Enter phone number',
	phone: 'Phone',
	full_name: 'Full Name',
	job_title: 'Job Title/ Position',
	search: 'Search:',
	filter_by: 'Filter By:',
};
